import React from "react";
import {jsonLdScript, pageSchema} from "../../helper/schema";
import BreadCrumb from "../Common/breadCrumb";
import Sidebar from "../Auth/AfterAuth/Sidebar";
import {NavLink} from "react-router-dom";
import {images} from "../../constant";
import Input from "react-phone-number-input/input";
import CommonStaticSidebar from "./commonStaticSidebar";
import BestSellerGrid from "./bestSellerGrid";
import {Helmet} from "react-helmet";
import {BASE_URL} from "../../helper";


import CustomerReviews from "../Common/CustomerReviews";
class Our_meat extends React.Component {

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        return (
            <>
                <React.Fragment>
                    <Helmet>
                        <meta charSet="utf-8" />
                        <title>Farmer's Fresh Meat - Our-Meat</title>
                        <meta name="description" content="Farmer's Fresh Meat is proud to be the best butcher shop and meat market in Houston, Texas. Buy wholesale beef, goat meat, chicken, and more - on sale now!"/>
                        <meta name="robots" content="index, follow"/>
                        <meta name="googlebot" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1"/>
                        <meta property="og:type" content="article"/>
                        <meta property="og:title" content="Farmer's Fresh Meat - Voted Best Meat Market/Butcher Shop in Houston"/>
                        <meta property="og:description" content="Farmer's Fresh Meat is proud to be the best butcher shop and meat market in Houston, Texas. Buy wholesale beef, goat meat, chicken, and more - on sale now!"/>
                        <meta property="og:url" content={BASE_URL() + this.props.location.pathname}/>
                        <meta property="og:site_name" content="Farmer&#039;s Fresh Meat: Houston Meat Market &amp; Butcher Shop"/>
                        <meta property="article:publisher" content="https://www.facebook.com/farmersfreshmeat"/>
                        <meta property="og:image" content={images.logoImg}/>
                        <meta property="og:image:width" content="1449"/>
                        <meta property="og:image:height" content="1024"/>
                        <meta name="twitter:card" content="summary"/>
                        <meta name="twitter:creator" content="Farmerfreshmeat"/>
                        <meta name="twitter:site" content="Farmerfreshmeat"/>
                        <link rel="canonical" href={BASE_URL() + this.props.location.pathname}/>
                        {jsonLdScript(pageSchema({type: 'WebPage', name: "Farmer's Fresh Meat - Our-Meat", pathname: this.props.location.pathname}))}
                    </Helmet>
                    {/*<div className="col-md-12 ">*/}
                    {/*    <div className="breadcrumb-details">*/}
                    {/*        <nav aria-label="breadcrumb">*/}
                    {/*            <ol className="breadcrumb">*/}
                    {/*                <li className="breadcrumb-item"><a href="/">Home</a></li>*/}
                    {/*                <li className="breadcrumb-item active" aria-current="page"><a>Career</a></li>*/}
                    {/*            </ol>*/}
                    {/*        </nav>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                    <div className="about-banner mb-3">
                        <div className="image-wrap">
                            <div className="img-content">
                                <img
                                    src={images.about}
                                    alt=""
                                    className="img-fluid"
                                />
                            </div>
                            <div className="overlay"></div>
                        </div>
                        <div className="banner-content">
                            <h1 >Meet the Farmers</h1>
                            <h5>Our Meat</h5>
                        </div>
                    </div>
                    <div className="container-fluid emp-form mb-fix mt-3">
                        <div className="col-12">
                            <div className="row">
                                <CommonStaticSidebar />
                                <div className="col-md-9">
                                    <div className="row justify-content-center">
                                        <div className="col-md-12 main-section bg-white mb-4">
                                            <div className="row">
                                                <div className="title pl-3 mb-3">
                                                    <h2 className="main-head">Our Guarantee of Excellence</h2>
                                                    <h6 className="mt-1 text-muted">Farmer’s take pride in the quality of all our meats.  Farmer’s receives its varieties of meat fresh, every single day. Our red meats are Texas farm raised cattle and shipped directly to our facility. Moreover, our receiving and processing system greatly shortens the time lapse between the slaughter and placement in the display case, thereby ensuring the absolute freshness of your delicious steak dinner. We are also pleased to certify that all of our meat are hormone and preservative free.  From our family to yours, we make sure that your loved ones enjoy only the best in cut and quality.  Check out our most popular products below and learn firsthand why “Fresh is Best!”</h6>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12 text-center title mb-3 mt-3">
                                            <h2 className="main-head">Checkout Our Bestsellers</h2>
                                            <BestSellerGrid />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                <CustomerReviews tag="meat"/>
                </React.Fragment>
            </>
        );
    }
}

export default Our_meat;



